export default __webpack_public_path__ + "static/media/team2.41b1ef3a.jpg";